import { render, staticRenderFns } from "./SearchResultsView.vue?vue&type=template&id=561692cb&scoped=true&"
import script from "./SearchResultsView.vue?vue&type=script&lang=js&"
export * from "./SearchResultsView.vue?vue&type=script&lang=js&"
import style0 from "./SearchResultsView.vue?vue&type=style&index=0&id=561692cb&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "561692cb",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VContainer})
